module.exports = __webpack_public_path__ + "static/media/CONTRATO PROFECO Satelital 234-2020.99b8ab6b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/CONTRATO PROFECO Satelital 234-2020.pdf
// module id = 355
// module chunks = 0